export interface ComplianceAppWebComponentSchema {
  // all the data needed for rendering
  data: any;
  externalFilters: Array<any>;
}

export enum ColumnKeys {
  CONTROL = 'controlDetails.name',
  CONTROL_ID = 'controlDetails.id',
  CATEGORY = 'category',
  SECTION = 'sectionDetails.name',
  SECTION_ID = 'sectionDetails.id',
  CONTROL_COMPLIANCE_SCORE = 'controlDetails.checksStats',
  COMPLIANT_COUNT = 'controlDetails.checksStats.checksResults.compliant',
  NON_COMPLIANT_COUNT = 'controlDetails.checksStats.checksResults.nonCompliant',
  IGNORED_COUNT = 'controlDetails.checksStats.checksResults.ignored',
  COMPLIANCE_STANDARD = 'complianceStandard',
  COMPANY = 'companyId',
}

// WARNING: Changing the order may break existing Smart Views
// because we save the order of the columns in the DB by the enum values.
// (eg. [0,1,3,4,2 ...])
export enum Column {
  CONTROL = 0,
  CONTROL_ID = 1,
  CATEGORY = 2,
  SECTION = 3,
  SECTION_ID = 4,
  CONTROL_COMPLIANCE_SCORE = 5,
  COMPLIANT_COUNT = 6,
  NON_COMPLIANT_COUNT = 7,
  IGNORED_COUNT = 8,
  // All columns below are for filtering only
  // thus, they are hidden from the main grid
  COMPLIANCE_STANDARD = 100,
  COMPANY = 101,
}
